var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var cleanUpCSVHeader = function (header) {
    return header
        .toUpperCase()
        .replace(/ /g, "")
        .replace(/[/?/:/(/)]/g, "");
};
var csvHeaderToAttributeMap = {
    YOURNAME: "first_name",
    LAST: "last_name",
    EMAILADDRESS: "email",
    PHONENUMBER: "phone",
    COUNTRY: "country",
    STATE: "state",
    CITY: "city",
    AREYOUANINDIVIDUALORASSOCIATEDWITHACOMPANY: "company_association",
    WHATISYOURTITLE: "company_title",
    COMPANYNAME: "company_name",
    COMPANYINDUSTRY: "company_industry",
    COMPANYWEBSITE: "company_website",
    ANNUALREVENUE: "company_revenue",
    AREYOUCURRENTLYPURCHASINGSEAWEED: "currently_purchasing",
    FROMWHICHREGIONSDOYOUCURRENTLYSOURCESEAWEED: "purchasing_regions",
    HOWISTHESEAWEEDYOUSOURCEGROWN: "seaweed_source",
    WHEREAREYOUINPRODUCTDEVELOPMENT: "prod_dev_phase",
    PLEASEDESCRIBEYOURPRODUCTS: "prod_description",
    WHICHSPECIESOFSEAWEEDAREYOUINTERESTEDINPURCHASING: "species_preferences",
    WHATFORMOFSEAWEEDSTABILIZATIONAREYOUINTERESTEDIN: "stabilization_preferences",
    WHATFORMOFSEAWEEDWOULDYOULIKETOBUY: "form_preferences",
    PURCHASINGTIMELINE: "purchasing_timeline",
    ESTIMATEDANNUALPURCHASEVOLUME: "purchase_volume",
    ANNUALVOLUMEFORM: "purchase_volume_form",
    TARGETPRICEPERPOUND: "target_price",
};
export var parseWufooCSV = function (data) {
    var headers = data[0].map(function (header) { return cleanUpCSVHeader(header); });
    var rowData = data[1];
    var tempResultObj = {};
    headers.forEach(function (header, index) {
        var cleanHeader = cleanUpCSVHeader(header);
        if (Object.keys(csvHeaderToAttributeMap).includes(cleanHeader)) {
            var payloadKey = csvHeaderToAttributeMap[cleanHeader];
            tempResultObj[payloadKey] =
                tempResultObj[payloadKey] === undefined ? [] : tempResultObj[payloadKey];
            tempResultObj[payloadKey] = __spreadArray(__spreadArray([], tempResultObj[payloadKey]), [
                rowData[index],
            ]);
        }
    });
    var resultObj = {};
    Object.keys(tempResultObj).forEach(function (payloadKey) {
        var valuesArray = tempResultObj[payloadKey];
        valuesArray = valuesArray.filter(function (v) { return v !== "" && v !== " "; });
        resultObj[payloadKey] =
            valuesArray.length === 0
                ? ""
                : valuesArray.length === 1
                    ? valuesArray[0]
                    : valuesArray.join(", ");
    });
    return resultObj;
};
//# sourceMappingURL=parseWufooCSV.js.map